module.exports = __webpack_public_path__ + "img/zfb.147508ed.png";